// Site-wide analytics loader — every ID comes from env; missing ID = silent no-op.
// GA4 + Meta Pixel load once for the whole site. Google Ads conversion, GA4
// partner_lead and Meta Lead fire ONLY on /partners/thank-you (see firePartnerConversions).

const GA4_ID = process.env.REACT_APP_GA4_ID || '';
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '';
const GADS_SEND_TO = process.env.REACT_APP_GADS_CONVERSION || ''; // "AW-XXXX/label" or "AW-XXXX"
const GADS_ID = GADS_SEND_TO.split('/')[0];

let booted = false;

export function initTracking() {
  if (booted || typeof window === 'undefined') return;
  booted = true;

  const baseTag = GA4_ID || GADS_ID;
  if (baseTag && !window.gtag) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${baseTag}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    if (GADS_ID) window.gtag('config', GADS_ID);
  }
  if (GA4_ID && window.gtag) window.gtag('config', GA4_ID);

  if (PIXEL_ID && !window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }
}

export function firePartnerConversions(leadId) {
  try {
    if (window.gtag) {
      if (GADS_SEND_TO) window.gtag('event', 'conversion', { send_to: GADS_SEND_TO, transaction_id: leadId || undefined });
      window.gtag('event', 'partner_lead', { lead_id: leadId || '' });
    }
    if (window.fbq) window.fbq('track', 'Lead', { content_name: 'partner_application' });
  } catch (e) { /* tracking must never break the page */ }
}
